var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "business_center"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2137_2140",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2137_2140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "business_center_2",
    d: "M4 21.5C3.45 21.5 2.97917 21.3042 2.5875 20.9125C2.19583 20.5208 2 20.05 2 19.5V8.5C2 7.95 2.19583 7.47917 2.5875 7.0875C2.97917 6.69583 3.45 6.5 4 6.5H8V4.5C8 3.95 8.19583 3.47917 8.5875 3.0875C8.97917 2.69583 9.45 2.5 10 2.5H14C14.55 2.5 15.0208 2.69583 15.4125 3.0875C15.8042 3.47917 16 3.95 16 4.5V6.5H20C20.55 6.5 21.0208 6.69583 21.4125 7.0875C21.8042 7.47917 22 7.95 22 8.5V19.5C22 20.05 21.8042 20.5208 21.4125 20.9125C21.0208 21.3042 20.55 21.5 20 21.5H4ZM10 6.5H14V4.5H10V6.5ZM20 15.5H15V17.5H9V15.5H4V19.5H20V15.5ZM11 15.5H13V13.5H11V15.5ZM4 13.5H9V11.5H15V13.5H20V8.5H4V13.5Z",
    fill: "#4D2481"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.d0a4eb4e149ba4d271f0e2aa20cf6836.svg";
export { ForwardRef as ReactComponent };